
Element.prototype.signUpHCPForm = () => {
    
    const testRegex = (r) => (x) => r.test(x);
    jQuery.validator.addMethod('validEmail', testRegex(/^(([0-9a-zA-Z])+([-._'+&]))*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$/));

    var response;
    function getState(){
        return jQuery.ajax({
            url: '/api/verify-zipcode?zipcode=' + document.getElementById('edit-mailing-address-postal-code').value + '&state=' + document.querySelector('select#edit-mailing-address-state-province').value,
            type: 'POST',
            data: 'JSON',
            async: false,
            success: function (data, textStatus, jqXHR) {
                if (jqXHR.status == 200) {
                response = (data.valid == true) ? true : false;
                }
            }
        }).done(function () {
            return response;
        });
    }
    jQuery.validator.addMethod('validState',
        function () {
            jQuery('select#edit-mailing-address-state-province').on('change', function(){
                jQuery('input#edit-mailing-address-postal-code').valid();
            });
            getState();
            return response;
        }
    );

    jQuery('.f-HCP').validate({
        rules: {
            registrant_type: "required",
            first_name: {
                required: true,
                maxlength: 50,
            },
            last_name: {
                required: true,
                maxlength: 50,
            },
            email: {
                required: true,
                validEmail: true,
                maxlength: 75,
            },
            "zip_code[postal_code]": {
                required: true,
                digits: true,
                minlength: 5,
                maxlength: 5,
            },
            hcp_credentials: "required",
            "mailing_address[address]": {
                required: "#edit-direct-mail-options-welcome-kit:checked,#edit-direct-mail-options-training-kit:checked",
                maxlength: 75,
            },
            "mailing_address[address_2]": {
                maxlength: 75,
            },
            "mailing_address[city]": {
                required: "#edit-direct-mail-options-welcome-kit:checked,#edit-direct-mail-options-training-kit:checked",
                maxlength: 50,
            },
            "mailing_address[state_province]": {
                required: "#edit-direct-mail-options-welcome-kit:checked,#edit-direct-mail-options-training-kit:checked",
            },
            "mailing_address[postal_code]": {
                required: "#edit-direct-mail-options-welcome-kit:checked,#edit-direct-mail-options-training-kit:checked",
                digits: true,
                minlength: 5,
                maxlength: 5,
                validState: true,
            },
        },
        messages: {
            registrant_type: "Please select this box to confirm you are a healthcare professional or requesting information on behalf of a healthcare professional.",
            first_name: "Please provide your first name.",
            last_name: "Please provide your last name.",
            email: {
                "required": "Please provide your email address.",
                "validEmail": "Please enter a valid email address.",
            },
            "zip_code[postal_code]": "Please enter a valid ZIP code (e.g., 12345).",
            hcp_credentials: "Please select an option from the menu that best describes you.",
            "mailing_address[address]": "Please provide your practice address.",
            "mailing_address[city]": "Please provide your city.",
            "mailing_address[state_province]": "Please provide your state.",
            "mailing_address[postal_code]": {
                required: "Please enter a valid ZIP code (e.g., 12345).",
                validState: "Please provide the correct ZIP code for your selected state.",
            },
        },
        errorPlacement: function(error, element) {
            let wrapper;
            if ( element[0].name === 'nayzilam_use_status' || element[0].name === 'registrant_type'  ) {
                wrapper = element.closest("fieldset")
            } else {
                wrapper = element.closest("fieldset, div.form-item")
            }
            console.log(element, wrapper)
            error.appendTo(wrapper);
        },
        errorClass: 'f-Form_Error'
    })


}

// Only run the function whenever there is an instance of a Eligibility Tool
if (document.querySelector('.f-HCP')) {
    jQuery(document).ready(function () {
        let zipCode = document.querySelector('input#edit-zip-code-postal-code');;
        let maZip = document.querySelector('input#edit-mailing-address-postal-code');
        const checkBox = document.querySelector('input#edit-direct-mail-options-welcome-kit');
        const checkBox2 = document.querySelector('input#edit-direct-mail-options-training-kit');
        
        var populateZipcode = function (zipcode) {
            if (zipcode !== '') {
                zipcode.setAttribute('value', zipcode.value);
                maZip.setAttribute('value', zipcode.value);
                maZip.value = zipcode.value;
            }
        };
        if ( zipCode ) {
            jQuery('input#edit-mailing-address-postal-code').one('input keyup blur', function () { 
                populateZipcode(zipCode); 
                checkBox.addEventListener('click', populateZipcode(zipCode));
                checkBox2.addEventListener('click', populateZipcode(zipCode));
                maZip.setAttribute('aria-invalid', 'false');
                maZip.classList.add('valid');
                    document.getElementById('edit-mailing-address-postal-code').value = document.getElementById('edit-zip-code-postal-code').value;
            });
        }
    });
    document.querySelector('.f-HCP').signUpHCPForm();
    populateEpilepsyCookie();
}






